import React, { useEffect, useState, useCallback } from "react";
import { axiosMaster } from "../api/axiosInstance";

const AddEditUserTypeMaster = ({ editData, onClose, onSuccess }) => {
  const storedUser = JSON.parse(localStorage.getItem("user") || "{}");

  const [userTypeName, setUserTypeName] = useState("");
  const [loading, setLoading] = useState(false);

  /* ================= TITLE CASE ================= */
  const toTitleCase = (text = "") =>
    text
      .toLowerCase()
      .split(" ")
      .filter(Boolean)
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(" ");

  /* ================= LOAD EDIT ================= */
  useEffect(() => {
    if (editData) {
      setUserTypeName(editData.userTypeName || "");
    } else {
      setUserTypeName("");
    }
  }, [editData]);

  /* ================= SUBMIT ================= */
  const handleSubmit = useCallback(async () => {
    if (loading) return;

    const formattedName = toTitleCase(userTypeName.trim());

    if (!formattedName) {
      alert("Enter user type name");
      return;
    }

    try {
      setLoading(true);

      const payload = {
        userTypeId: editData?.userTypeId || 0,
        userTypeName: formattedName,
        createdBy: storedUser?.userId || 0,
        modifiedBy: storedUser?.userId || 0,
        status: true, // optional if backend requires it
      };

      if (editData?.userTypeId) {
        // 🟡 UPDATE
        await axiosMaster.put(`/UserTypeMaster/${editData.userTypeId}`, payload);
      } else {
        // 🟢 ADD
        await axiosMaster.post("/UserTypeMaster", payload);
      }

      onSuccess?.();
      onClose?.();
    } catch (err) {
      console.error("Save error:", err);
      alert("Error saving user type");
    } finally {
      setLoading(false);
    }
  }, [userTypeName, editData, onClose, onSuccess, loading, storedUser?.userId]);

  /* ================= KEYBOARD ================= */
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSubmit();
    }
    if (e.key === "Escape") {
      onClose?.();
    }
  };

  /* ================= CHANGE ================= */
  const handleChange = (e) => {
    const value = e.target.value.replace(/\s{2,}/g, " ");
    setUserTypeName(value);
  };

  const handleBlur = () => {
    setUserTypeName((prev) => toTitleCase(prev));
  };

  /* ================= UI ================= */
  return (
    <div
      className="fixed inset-0 bg-black/40 flex justify-center items-center z-50"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-xl w-[400px] p-4"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="text-lg font-semibold mb-3">
          {editData ? "Edit User Type" : "Add User Type"}
        </h3>

        <input
          type="text"
          value={userTypeName}
          onChange={handleChange}
          onBlur={handleBlur}
          onKeyDown={handleKeyDown}
          placeholder="Enter user type name"
          autoFocus
          className="w-full border px-3 py-2 rounded-lg mb-4 focus:ring-2 focus:ring-blue-500 outline-none"
        />

        <div className="flex justify-end gap-2">
          <button
            onClick={onClose}
            className="px-3 py-2 border rounded-lg hover:bg-gray-100"
          >
            Cancel
          </button>

          <button
            onClick={handleSubmit}
            disabled={loading}
            className="px-3 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50"
          >
            {loading ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddEditUserTypeMaster;